import * as types from "../actions/types";
import baseStore from "./utils/baseStore";

export const userPersonalWorkspace = baseStore(types.USER_PERSONAL_WORKSPACE);  
export const userOrganisationWorkspace = baseStore(types.USER_ORGANISATION_WORKSPACE);  

